import React from "react";

const PageLoader: React.FC<{ visible: boolean }> = ({ visible }) => (
  <div
    className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#0f2e29] transition-opacity duration-500 ${
      visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
    }`}
  >
    <div className="flex flex-col items-center gap-5">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1a4a43]">
        <span className="font-display font-light text-2xl font-semibold text-[#c9a96e]">LP</span>
      </div>
      <div className="flex gap-1.5">
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#c9a96e] [animation-delay:0ms]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#c9a96e] [animation-delay:150ms]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#c9a96e] [animation-delay:300ms]" />
      </div>
    </div>
  </div>
);

export default PageLoader;
